import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { StateComponent } from '../../../../../common/components/state/state.component';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormApiService } from '../../../../../common/apis/form/form-api.service';
import { NotificationService } from '../../../../../common/services/notification.service';
import { IFormModel } from '../../../../../common/apis/form/model/form.model';
import { IFormBettings } from '@oogaday/shared';
import { AnalyticsService } from '../../../../../common/services/analytics.service';
import { MatDialog } from '@angular/material/dialog';
import { SubmitFormDialogComponent, SubmitFormDialogComponentReturnData } from './submit-form-dialog/submit-form-dialog.component';
import { FormFillerComponent } from '../../../../../common/modules/form-actions/common/components/form-filler/form-filler.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'oo-form-submission',
  templateUrl: './form-submission.component.html',
  styleUrls: ['./form-submission.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormFillerComponent],
})
export class FormSubmissionComponent extends StateComponent<FormSubmissionComponentState> implements OnInit {

  private readonly fb = inject(UntypedFormBuilder);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly formApi = inject(FormApiService);
  private readonly notificationService = inject(NotificationService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly dialog = inject(MatDialog);

  state: FormSubmissionComponentState = {
    tournamentId: this.route.snapshot.paramMap.get('tournamentId')!,
    dataFetcher: this.dataFetcher.bind(this),
    dataSaver: this.dataSaver.bind(this),
  };

  ngOnInit(): void {
    this.analyticsService.trackScreenName('formSubmission');
  }

  onSave(): void {
    this.notificationService.notify('Betting results were saved');
    this.router.navigate(['../../forms'], {
      relativeTo: this.route,
    });
  }

  dataSaver(data: IFormBettings<any>): Promise<boolean> {
    return firstValueFrom(this.dialog.open<SubmitFormDialogComponent, void, SubmitFormDialogComponentReturnData>(SubmitFormDialogComponent)
      .afterClosed())
      .then((res => {
        if (res!.submit) {
          return this.formApi.submitFormResult(
            this.state.tournamentId, this.route.snapshot.paramMap.get('formId')!, data, res!.notify)
            .then(() => true);
        } else {
          return Promise.resolve(false);
        }
      }));
  }

  private dataFetcher(): Promise<IFormModel> {
    return this.formApi.getFormById(this.route.snapshot.paramMap.get('tournamentId')!,
      this.route.snapshot.paramMap.get('formId')!, ['bettingResult', 'config', 'metadata']);
  }
}

interface FormSubmissionComponentState {
  tournamentId: string;
  dataFetcher: () => Promise<IFormModel>;
  dataSaver: (betting: IFormBettings<any>) => Promise<any>;
}
